/**
 * Component NaviSubnaviToggler
 *
 * Fügt der Navigation die Möglichkeit hinzu, die Subnavigation per Touch oder Klick zu aktivien und zu deaktiviern
 * 
 */
export class NaviSubnaviToggler {
    constructor(triggername) {
        this.triggername = triggername;
        this.triggers = document.querySelectorAll(triggername);
        this.listeners();
    }
    listeners() {
        this.triggers.forEach(sel => {
            sel.addEventListener('click', sel => this.toggleNavi(sel), false);
        });

        // Wenn ausserhalb der Navi geklickt wird, Subnavi schließen
        window.addEventListener('click', event => {
            if (!event.target.parentNode.classList.contains('js-navi-toggler')) {
                // console.log('Close');
                this.closeNavi();
            }
        });
        window.addEventListener('keydown', event => {
            let key = event.keyCode;
            if (key === 27) {
                this.closeNavi();
            }
        });
    }
    toggleNavi(el) {
        // erst alle anderen schließen
        this.closeNavi();
        let sel = el.target.parentNode;
        if (sel.classList.contains("-state--active") || sel.classList.contains("-state--off")) {
            sel.classList.toggle("-state--off");
        }
        sel.classList.toggle("-state--active");
    }
    closeNavi() {
        this.triggers.forEach(sel => {
            sel.classList.remove("-state--active");
        });
    }
}

// Der Subnavi Toggler wird nur aktiviert, wenn der Client Touchfähig ist:
const touchSupported = () => ('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch);

if (touchSupported() === true) {
    new NaviSubnaviToggler(".js-navi-toggler");
}